// Add your custom JS here.
(function () {
	'use strict';

	var header = document.getElementById( 'site-header' );

	if ( ! header ) {
		return;
	}

	var ticking = false;

	function updateHeader() {
		header.classList.toggle( 'is-sticky', window.scrollY > 120 );
		ticking = false;
	}

	function requestHeaderUpdate() {
		if ( ticking ) {
			return;
		}

		ticking = true;
		window.requestAnimationFrame( updateHeader );
	}

	updateHeader();
	window.addEventListener( 'scroll', requestHeaderUpdate, { passive: true } );
}());
